import { createFileRoute } from '@tanstack/react-router'
import { StateModelsPage } from '@/pages/settings/state-models-page'
import { WorkspaceEntitlementGate } from '@/features/workspace-entitlements/ui/workspace-entitlement-gate'
import { WorkspaceEntitlementKey } from '@/graphql/schema'

export const Route = createFileRoute('/settings/state-models_/')({
  component: () => (
    <WorkspaceEntitlementGate
      feature={WorkspaceEntitlementKey.StateModelConfiguration}
    >
      <StateModelsPage />
    </WorkspaceEntitlementGate>
  ),
})
